import React from 'react'
import { Link } from 'react-router'

export default class LinkDashboard extends React.Component {
  render () {
    var url = 'health/' + this.props.numeroDocumento
    return (
        <Link className='link-table-date' key={0} to={url}>{this.props.data}</Link>
    )
  }
}

/* Validate Props */
LinkDashboard.propTypes = {
  rowData: React.PropTypes.object,
  data: React.PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Search/LinkMedicalData.js